import React from 'react';
import SessionRanking from './SessionRanking';
import { isSinglesFormat } from '../../utils/competitiveMatchFormat';

/**
 * Competitive session Session Ranking tab: live leaderboard for the session.
 */
function SessionRankingTab({
  sessionId,
  playersById,
  selectedClub,
  season,
  sessionPlayerStatus,
  matchFormat = 'doubles',
  refreshKey = 0,
  localGames = null,
}) {
  return (
    <SessionRanking
      sessionId={sessionId}
      playersById={playersById}
      selectedClub={selectedClub}
      season={season}
      sessionPlayerStatus={sessionPlayerStatus}
      useSinglesEloColumns={isSinglesFormat(matchFormat)}
      refreshKey={refreshKey}
      localGames={localGames}
    />
  );
}

export default SessionRankingTab;
